// extracted by mini-css-extract-plugin
module.exports = {"button":"_1oDhP","small":"_2MZlH","secondary":"_1BQQH","isMuted":"ZsMFP","wrapper":"_1NKQw","load6":"xMI78"};